import { cloneDeep, isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'GeneratorRow',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    defaultValue: {
      type: [ Object, Array, String ],
      default: () => {
        return {}
      }
    },

    disabled: Boolean,
    addDisabled: Boolean,
    readonly: Boolean,

    sortable: Boolean,
    sortableProperty: {
      type: String,
      default: 'priority'
    },

    sortBy: {
      type: String,
      default: undefined
    },

    min: Number,
    max: Number,

    gap: {
      type: [ String, Number ],
      default: 12
    }
  },

  computed: {
    canAdd() {
      return this.disabled || this.addDisabled || this.max && this.proxy.length >= this.max
    },

    canSortable() {
      return this.sortable && !this.readonly
    },
    canSortBy() {
      return this.sortBy && !this.readonly
    }
  },

  methods: {
    addField() {
      if (this.max && this.proxy.length >= this.max) {
        return
      }

      this.proxy.push(cloneDeep(this.defaultValue))
    },
    removeField(index) {
      if (this.min && this.proxy.length <= this.min) {
        return
      }

      this.proxy.splice(index, 1)
      if (this.proxy.length === 0) {
        this.addField()
      }
    },

    sorter(items) {
      if (this.canSortable) {
        for (let index = 0; index < items.length; index++) {
          items[index][this.sortableProperty] = index
        }
      }
    },
    sort(value) {
      if (this.sortBy) {
        value.sort((a, b) => {
          const va = String(a[this.sortBy] || '').toLocaleLowerCase()
          const vb = String(b[this.sortBy] || '').toLocaleLowerCase()

          return va.localeCompare(vb)
        })
      }
    },

    _inputFilter(value) {
      const result = cloneDeep(value) || []
      if (result.length === 0) {
        result.push(cloneDeep(this.defaultValue))
      }
      this.sorter(result)

      return result
    },
    _outputFilter(value) {
      const result = cloneDeep(value) || []
      this.sorter(result)

      return result
    },

    watchProxyHandler() {
      if (!isEqual(this.proxy, this.value)) {
        this.transmitValue()
      }
    }
  },

  render
}
